<template>
  <a-spin :spinning="spinning">
    <template #indicator>
      <Loading></Loading>
    </template>
    <div>
      <div class="payments" v-if="orderDetails && !refreshPage">
        <PcUnsubscribe ref="pcCheckout" class="pc-checkout" :order="orderDetails"></PcUnsubscribe>
      </div>
    </div>
  </a-spin>
</template>
<script>
import { getOrderInfo } from '@/views/subscribe/api'
import { mapActions } from 'vuex'
import PcUnsubscribe from '@/views/subscribe/unsubscribe/components/pc.vue'
import Loading from '@/components/loading'

export default {
  components: { PcUnsubscribe, Loading },
  data() {
    return {
      orderDetails: null,
      orderId: this.$route.params.id,
      spinning: false,
      refreshPage: false,
      isPC: true
    }
  },
  async created() {
    await this.initOrderInfo()
  },
  mounted() {
    // 添加事件监听
    window.addEventListener('beforeunload', this.onBeforeUnload)
  },
  methods: {
    ...mapActions('app', ['applyTheme']),
    async initOrderInfo() {
      try {
        this.spinning = true
        await getOrderInfo(this.orderId).then((res) => {
          if (!res.data) {
            this.spinning = false
            this.$router.push({
              name: 'SubscribeFailed',
              params: { id: this.orderId }
            })
            return
          }
          this.orderDetails = res.data
          // 根据后端返回的主题标识应用主题
          // if (res.data && res.data.theme) {
          //   this.applyTheme(res.data.theme)
          // }
        })
        this.spinning = false
      } catch (error) {
        console.error(error)
        this.spinning = false
      }
    },
    onLanguageChange() {
      this.refreshPage = true
      this.$nextTick(() => {
        this.refreshPage = false
      })
    }
  },
  watch: {
    '$store.getters.app.currentLan': 'onLanguageChange'
  }
}
</script>
<style lang="less" scoped>
@import '~@/styles/common.less';
@import '~@/views/checkout/styles/index.less';
</style>
